<div class="flex-fill d-flex flex-column card p-3">
  <div class="card">
    <div class="card-body" style="max-width: 1050px">
      <dx-form [formData]="filter" appAutofocusForm="partNumber" [colCount]="3" (onEditorEnterKey)="search()">
        <dxi-item itemType="group">
          <dxi-item
            dataField="customerId"
            editorType="dxSelectBox"
            [label]="{ text: 'Customer' }"
            [editorOptions]="{ dataSource: customersDS, displayExpr: 'name', valueExpr: 'id', showClearButton: true }"
          ></dxi-item>
          <dxi-item
            dataField="productId"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: productsDS, displayExpr: 'name', valueExpr: 'id', showClearButton: true }"
            [label]="{ text: 'Product' }"
          ></dxi-item>
          <dxi-item dataField="ticketNumber" editorType="dxNumberBox" [label]="{ text: 'Ticket #' }"></dxi-item>
        </dxi-item>
        <dxi-item itemType="group" [colSpan]="2" [colCount]="2">
          <dxi-item dataField="loadDateStart" editorType="dxDateBox"></dxi-item>
          <dxi-item dataField="loadDateEnd" editorType="dxDateBox"></dxi-item>
        </dxi-item>
      </dx-form>
      <div class="btn-toolbar justify-content-end align-items-center mt-1">
        @if (loads) {
          <div class="me-3">{{ loads.length }} {{ loads.length === 1 ? "item found" : "items found" }}</div>
        }
        <button accesskey="s" (click)="search()" class="btn btn-primary">Search</button>
        <button (click)="clear()" class="btn btn-secondary ms-2">Clear</button>
      </div>
    </div>
  </div>
  <div class="d-flex flex-fill flex-column">
    <dx-data-grid
      #dataGrid
      keyExpr="id"
      class="flex-fill d-flex flex-column"
      [dataSource]="loads"
      (onRowPrepared)="onRowPrepared($event)"
      (onCellPrepared)="onCellPrepared($event)"
      >
      <dxi-column dataField="id" width="65"></dxi-column>
      <dxi-column dataField="ticketAttachmentTypeName" caption="Type" width="100"></dxi-column>
      <dxi-column dataField="loadDate" dataType="date" width="100"></dxi-column>
      <dxi-column dataField="ticketNumber" width="100"></dxi-column>
      <dxi-column dataField="invoiceNumber" caption="Invoice #" width="100" cellTemplate="invoiceLinkTemplate"></dxi-column>
      <dxi-column dataField="customerString" caption="Customer Code" width="100"></dxi-column>
      <dxi-column dataField="companyName" caption="Company Name" width="175" cellTemplate="linkTemplate"></dxi-column>
      <dxi-column dataField="description1" width="125" [sortIndex]="0" [sortOrder]="'asc'"></dxi-column>
      <dxi-column dataField="description2" width="125" [sortIndex]="1" [sortOrder]="'asc'"></dxi-column>
      <dxi-column dataField="productId" width="100"></dxi-column>
      <dxi-column dataField="productString" width="125"></dxi-column>
      <dxi-column dataField="price" width="115" [format]="{ type: 'currency', precision: 2 }" [editorOptions]="{ step: 0 }"></dxi-column>
      <dxi-column dataField="priceVerified" dataType="date" width="125"></dxi-column>
      <dxi-column dataField="loadAdditivesHtml" caption="Additives" width="275" [encodeHtml]="false"></dxi-column>
      <dxi-column dataField="weightQuantity" width="125"></dxi-column>
      <dxi-column dataField="yardQuantity" width="125"></dxi-column>
      <dxi-column dataField="uniqueId" width="100"></dxi-column>
      <dxi-column dataField="mixString" width="115"></dxi-column>
      <dxi-column dataField="carrier" width="175"></dxi-column>
      <dxi-column dataField="vehicle" width="175"></dxi-column>
      <dxi-column dataField="order" width="125"></dxi-column>
      <dxi-column dataField="poNumber" width="125"></dxi-column>
      <dxi-column dataField="tareWeight" width="175"></dxi-column>
      <dxi-column dataField="grossWeight" width="175"></dxi-column>
      <dxi-column dataField="netWeight" width="175"></dxi-column>
      <dxi-column dataField="unitOfMeasure" width="175"></dxi-column>
      <dxi-column></dxi-column>

      <div *dxTemplate="let cell of 'linkTemplate'">
        @if (cell.data) {
          <a [routerLink]="[]" (click)="openCustomer(cell.data.customerId)">{{ cell.text }}</a>
        }
      </div>

      <div *dxTemplate="let cell of 'invoiceLinkTemplate'">
        @if (cell.data?.invoiceId) {
          <a [routerLink]="['/invoices', cell.data.invoiceId]">{{ cell.text }}</a>
        }
      </div>

      <dxo-sorting [mode]="'multiple'"></dxo-sorting>
      <dxo-selection mode="multiple"></dxo-selection>
      <dxo-search-panel [visible]="true"></dxo-search-panel>
      <dxo-filter-row [visible]="true"></dxo-filter-row>
      <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
      <dxo-state-storing [enabled]="true" type="localStorage" storageKey="load-history-grid"></dxo-state-storing>
      <div *dxTemplate="let data of 'toolbarButtons'"></div>
      <div *dxTemplate="let data of 'toolbarText'">
        @if (loads) {
          <span class="me-3">
            <strong>
              {{ dataGrid.instance.totalCount() + " items" }}
              {{ dataGrid.instance.getSelectedRowsData().length > 0 ? dataGrid.instance.getSelectedRowsData().length + " selected" : "" }}
            </strong>
          </span>
        }
      </div>
    </dx-data-grid>
  </div>
</div>
